import React from 'react';
import PropTypes from 'prop-types';

import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';
import { counterOfferRounding } from '@app/dev/helpers/sport/betslip';
import { getAuthData } from '@common/helpers/auth';

const SuperbetOfferChange = ({
  acceptOffer, rejectOffer, newOdd, newAmount, isCounterOffer,
}) => {
  const t = useTranslation();
  const { currency } = getAuthData();

  return (
    <div className="popup-content popup-small superbet-popup superbet-offer-change">
      <h3 className="popup-title">{isCounterOffer ? t('Counter Offer') : t('Superbet')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t('Your offer has been changed')}</p>

        <p className="superbet-new-offer">{t('New offer')}</p>

        <div className="superbet-new-odd">
          <p className="offer-change-text">
            {t('Odd')}
          </p>
          <span>{counterOfferRounding(newOdd)}</span>
        </div>

        <div className="superbet-new-amount">
          <p className="offer-change-text">
            {t('Amount')}
          </p>
          <span>
            {Config.useCurrencySymbol ? Config.currencySymbol[currency] + newAmount : `${newAmount} ${currency}`}
          </span>
        </div>
      </div>
      <button
        type="button"
        onClick={rejectOffer}
        className="popup-cancel-button"
      >
        {t('Cancel')}
      </button>

      <button
        type="button"
        onClick={acceptOffer}
        className="popup-confirm-button"
      >
        {t('Accept')}
      </button>
    </div>
  );
};

SuperbetOfferChange.propTypes = {
  acceptOffer: PropTypes.func,
  rejectOffer: PropTypes.func,
  newOdd: PropTypes.number,
  newAmount: PropTypes.number,
  isCounterOffer: PropTypes.bool,
};

export default SuperbetOfferChange;
